/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import { PenTool } from 'lucide-react';
import { FileText } from 'lucide-react';
import { Layout } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Box, Divider, Grid, GridItem, HStack, useDisclosure } from '@chakra-ui/react';
import { PanelRightClose, PanelRightOpen, Box as BoxIcon } from 'lucide-react';
import { useContext, useEffect, useState } from 'react';

import { AppContext } from '@context';
import { useAppToast } from '@hooks';
import { lang } from '@lang';
import { ContentPanelMode, selectContentPanelMode, selectContextPanelCount, selectContextPanelIsOpen, selectEstimatePanelIsOpen, setContentPanelMode, setContextPanelIsOpen, setEstimatePanelIsOpen, useAppDispatch, useAppSelector } from '@state';
import { BlueprintFileMenu } from './blueprint-file-menu';
import { RtaFeatureIconButton, RtaIconButton } from '@components';
import { showAboutFeature, useAutoZoomFeature, useCountertopPropertiesFeature, useCrmFeature, useSlackFeature, useDecreaseFontSizeFeature, useFindCustomerFeature, useIncreaseFontSizeFeature, useKitchenPropertiesFeature, useNewCustomerFeature, useRenderingPropertiesFeature, useSaveFeature, useShowAllDimensions, useShowGridFeature } from '@features';

export const OptionsBar = () => {
	const { appState: { customerDesigns }} = useContext(AppContext);

	const { isOpen, onOpen, onClose } = useDisclosure();
	const [state, setState] = useState('');
	const [error, setError] = useState('');
	const [email, setEmail] = useState('');

	const navigate = useNavigate();
	const appToast = useAppToast();

	const dispatch = useAppDispatch();
	const contentPanelMode = useAppSelector(selectContentPanelMode);
	const contextPanelCount = useAppSelector(selectContextPanelCount);
	const contextPanelIsOpen = useAppSelector(selectContextPanelIsOpen);
	const estimatePanelIsOpen = useAppSelector(selectEstimatePanelIsOpen);

	// const navigation = useAppSelector(selectNavigation);

	const rulerFeature = useShowGridFeature();
	const autoZoomFeature = useAutoZoomFeature();
	const aboutFeature = showAboutFeature();
	const countertopPropertiesFeature = useCountertopPropertiesFeature();
	const kitchenPropertiesFeature = useKitchenPropertiesFeature();
	const renderingPropertiesFeature = useRenderingPropertiesFeature();
	const saveFeature = useSaveFeature();
	const findCustomerFeature = useFindCustomerFeature();
	const newCustomerFeature = useNewCustomerFeature();
	const crmFeature = useCrmFeature();
	const slackFeature = useSlackFeature();
	// const showAllDimensions = useShowAllDimensions();
	// const increaseFontSize = useIncreaseFontSizeFeature();
	// const decreaseFontSize = useDecreaseFontSizeFeature();

	useEffect(() => {
		if (!email || email === 'r') return;
		const normalized = email.replace(/^(?:\/?r\/)+/i, '');
		navigate(`/r/${normalized}`, { replace: true });
		onClose();
		setEmail('');
	}, [state]);

	useEffect(() => {
		if (error !== '') {
			appToast.error({ title: lang.customer.message.errorFetchingUser });
		}
	}, [error]);


	return (
		<Box w={'calc(100% - 2px)'} h={'calc(100% - 2px)'} m={'1px'}>
			<Grid templateColumns={'5px auto 5px 70px'} w={'100%'} h={'100%'} gap={'0'}>
				<GridItem><Divider orientation={'vertical'} /></GridItem>
				<GridItem border="0px">
					<HStack>
						<RtaFeatureIconButton feature={findCustomerFeature} />
						<RtaFeatureIconButton feature={newCustomerFeature} />
						<RtaFeatureIconButton feature={saveFeature} />
						<BlueprintFileMenu />
						<Divider h={'30px'} my={'2px'} orientation={'vertical'}/>

						<RtaFeatureIconButton feature={crmFeature} />
						<RtaFeatureIconButton feature={slackFeature} />
						<Divider h={'30px'} my={'2px'} orientation={'vertical'}/>

						<RtaIconButton icon={<PenTool />} label="Designer"
							onClick={() => dispatch(setContentPanelMode(ContentPanelMode.Designer))}
						/>
						<RtaIconButton icon={<BoxIcon />} label="3D Viewer"
							onClick={() => dispatch(setContentPanelMode(ContentPanelMode.ThreeD))}
						/>
						<Divider h={'30px'} my={'2px'} orientation={'vertical'}/>

						<RtaFeatureIconButton feature={kitchenPropertiesFeature} />
						<RtaFeatureIconButton feature={countertopPropertiesFeature} />
						<RtaFeatureIconButton feature={renderingPropertiesFeature} />
						<Divider h={'30px'} my={'2px'} orientation={'vertical'}/>

						<RtaFeatureIconButton feature={rulerFeature} />
						<RtaFeatureIconButton feature={autoZoomFeature} />
						{/* <RtaFeatureIconButton feature={showAllDimensions} /> */}

						<Divider h={'30px'} my={'2px'} orientation={'vertical'}/>

						<RtaFeatureIconButton feature={aboutFeature} />

						{/* <RtaFeatureIconButton feature={increaseFontSize} />
						<RtaFeatureIconButton feature={decreaseFontSize} /> */}
						{/* <RtaIconButton icon={<PlusCircle/>} label={lang.customer.tooltip.clickToAddCustomer} onClick={ onOpen } /> */}
					</HStack>
				</GridItem>
				<GridItem><Divider orientation={'vertical'} /></GridItem>
				<GridItem border="0px">
					<HStack>
						<RtaIconButton
							enabled={ customerDesigns && customerDesigns.designs.length > 0 && contentPanelMode !== ContentPanelMode.findCustomer }
							icon={<FileText/>}
							label={`${estimatePanelIsOpen ? 'Hide' : 'Open'} Estimate`}
							onClick={() => dispatch(setEstimatePanelIsOpen(!estimatePanelIsOpen))}
						/>
						<RtaIconButton
							enabled={ customerDesigns && customerDesigns.designs.length > 0 && contentPanelMode !== ContentPanelMode.findCustomer && contextPanelCount > 0}
							icon={ contextPanelIsOpen ? <PanelRightClose /> : <PanelRightOpen />}
							label={`${contextPanelIsOpen ? 'Hide' : 'Open'} Context Panel`}
							onClick={() => dispatch(setContextPanelIsOpen(!contextPanelIsOpen))}
						/>
					</HStack>
				</GridItem>
			</Grid>
		</Box>
	);
};
